export function isWorkHubTabGroup(item) {
    return 'groupKey' in item;
}
export function isWorkHubTab(item) {
    return !isWorkHubTabGroup(item);
}
//# sourceMappingURL=utils.js.map